/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Better_Studio_Month_JanInputs */

const en_better_studio_month_jan = /** @type {(inputs: Better_Studio_Month_JanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jan`)
};

/**
* | output |
* | --- |
* | "Jan" |
*
* @param {Better_Studio_Month_JanInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const better_studio_month_jan = /** @type {((inputs?: Better_Studio_Month_JanInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Better_Studio_Month_JanInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_better_studio_month_jan(inputs)
});